import { render, staticRenderFns } from "./screenWordCloud.vue?vue&type=template&id=d25dd252&scoped=true"
import script from "./screenWordCloud.vue?vue&type=script&lang=js"
export * from "./screenWordCloud.vue?vue&type=script&lang=js"
import style0 from "./screenWordCloud.vue?vue&type=style&index=0&id=d25dd252&prod&lang=scss"
import style1 from "./screenWordCloud.vue?vue&type=style&index=1&id=d25dd252&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d25dd252",
  null
  
)

export default component.exports